// extracted by mini-css-extract-plugin
export var title = "backers-module--title--1YlFe";
export var logoContainer = "backers-module--logoContainer--twTRy";